import React, { useState, useEffect } from 'react';
import './OrderInfoItem.scss';
import {getImageUrl} from "../../api/iposApi";
import FormattedPrice from "../../components/FormattedPrice";
import PizzaPart from "../../components/PizzaPart";
import cutlery_icon from '../../assets/img/icons/cutlery.png';
import { withTranslation } from 'react-i18next';

const UtensilsInfoItem = ({ item, t }) => {
  return (
    <div className={'order-item-info'}>
      <div className={'img-block'}>
        <img
          src={ cutlery_icon }
          className="img-responsive"
          alt="iPos Web Delivery" />
      </div>
      <div className={'info-block'}>
        <div className={'parent-item-info'}>
          <div className={'item-info-block'}>
            <div className={'item-name'}>{ t('client_details.utensils') }</div>
            <div className={'item-description'}>{item.menuItem.details_txt}</div>
          </div>

          <div className={'item-quantity-info-block'}>
            <div className={'item-quantity-info'}>x {item.orderItem.quantity}</div>
          </div>

          <div className={'item-price-block'}>
            <div className={'item-price'}>
              <FormattedPrice price={ item.orderItem.price } />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default withTranslation()(UtensilsInfoItem);
